"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectiveKeyMap = exports.interactionKeyMap = exports.baseKeyMap = void 0;
var baseKeyMap = {
    entry: {
        local: "entry",
        "1.2": "cmi.core.entry",
        "2004": "cmi.entry",
    },
    suspendData: {
        local: "suspendData",
        "1.2": "cmi.suspend_data",
        "2004": "cmi.suspend_data",
    },
    sessionTime: {
        local: "sessionTime",
        "1.2": "cmi.core.session_time",
        "2004": "cmi.session_time",
    },
    scoreScaled: {
        local: "scoreScaled",
        "1.2": null,
        "2004": "cmi.score.scaled",
    },
    scoreRaw: {
        local: "scoreRaw",
        "1.2": "cmi.core.score.raw",
        "2004": "cmi.score.raw",
    },
    studentName: {
        local: "studentName",
        "1.2": "cmi.core.student_name",
        "2004": "cmi.learner_name",
    },
    launchData: {
        local: "launchData",
        "1.2": "cmi.cmi.launch_data",
        "2004": "cmi.cmi.launch_data",
    },
    completeStatus: {
        local: "completionStatus",
        "1.2": "cmi.core.lesson_status",
        "2004": "cmi.completion_status",
    },
    successStatus: {
        local: "successStatus",
        "1.2": "cmi.core.lesson_status",
        "2004": "cmi.success_status",
    },
    language: {
        local: "language",
        "1.2": "cmi.student_preference.language",
        "2004": "cmi.learner_preference.language",
    },
    scoreMin: {
        local: "scoreMin",
        "1.2": "cmi.core.score.min",
        "2004": "cmi.score.min",
    },
    scoreMax: {
        local: "scoreMax",
        "1.2": "cmi.core.score.max",
        "2004": "cmi.score.max",
    },
    location: {
        local: "location",
        "1.2": "cmi.core.lesson_location",
        "2004": "cmi.location",
    },
    objectiveList: {
        local: "objectiveList",
        "1.2": "cmi.objectives._children",
        "2004": "cmi.objectives._children",
    },
    interactionsCount: {
        local: "interactionsCount",
        "1.2": "cmi.interactions._count",
        "2004": "cmi.interactions._count",
    },
    objectivesCount: {
        local: "objectivesCount",
        "1.2": "cmi.objectives._count",
        "2004": "cmi.objectives._count",
    },
    progressMeasure: {
        local: "progressMeasure",
        "1.2": null,
        "2004": "cmi.progress_measure",
    },
    exit: {
        local: "exit",
        "1.2": "cmi.core.exit",
        "2004": "cmi.exit",
    },
};
exports.baseKeyMap = baseKeyMap;
var interactionKeyMap = {
    id: {
        local: "id",
        "1.2": "id",
        "2004": "id",
    },
    weight: {
        local: "weight",
        "1.2": "weighting",
        "2004": "weighting",
    },
    learnerResponse: {
        local: "learnerResponse",
        "1.2": "student_response",
        "2004": "learner_response",
    },
    result: {
        local: "result",
        "1.2": "result",
        "2004": "result",
    },
    objectiveIdList: {
        local: "objectiveIdList",
        "1.2": "_children",
        "2004": "_children",
    },
    timestamp: {
        local: "timestamp",
        "1.2": "time",
        "2004": "timestamp",
    },
    latency: {
        local: "latency",
        "1.2": "latency",
        "2004": "latency",
    },
    type: {
        local: "type",
        "1.2": "type",
        "2004": "type",
    },
    description: {
        local: "description",
        "1.2": "objectives",
        "2004": "description",
    },
};
exports.interactionKeyMap = interactionKeyMap;
var objectiveKeyMap = {
    id: {
        local: "id",
        "1.2": "id",
        "2004": "id",
    },
    scoreRaw: {
        local: "scoreRaw",
        "1.2": "score.raw",
        "2004": "score.raw",
    },
    scoreMax: {
        local: "scoreMax",
        "1.2": "score.max",
        "2004": "score.max",
    },
    scoreMin: {
        local: "scoreMin",
        "1.2": "score.min",
        "2004": "score.min",
    },
    successStatus: {
        local: "successStatus",
        "1.2": "status",
        "2004": "success_status",
    },
    completionStatus: {
        local: "completionStatus",
        "1.2": "status",
        "2004": "completion_status",
    },
    description: {
        local: "description",
        "1.2": "id",
        "2004": "description",
    },
};
exports.objectiveKeyMap = objectiveKeyMap;
//# sourceMappingURL=scormKeymap.js.map